<template>
  <div class="topi-background px-1 py-half rounded" :class="{ small }">
    <img :src="topi" class="topi-logo" />
  </div>
</template>

<script setup lang="ts">
import topi from '@/assets/images/topi.svg'

defineProps({
  small: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss" scoped>
.topi-background {
  background-color: #18191b;
  max-height: 25px;
  max-width: 48px;
  height: 25px;
  width: 48px;
}

.topi-logo {
  max-height: 17px;
  max-width: 32px;
  height: 17px;
  width: 32px;
}

.small {
  transform: scale(0.8);
}
</style>
